import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import Loader from '../../../Utilities/Loader/Loader';

import './PrizesChart.css';

function PrizesChart(props) {

  const [chartData, setChartData] = useState({
    '2017': [],
    '2018': [],
    '2019': [],
    '2020': []
  });

  const [chartLabel, setChartLabel] = useState([]);
  const [barStyle, setBarStyle] = useState({
    height: '100%',
    width: '1200%',
    marginBottom: '10px',
    position: 'relative'
  });

  useEffect(() => { 
    // console.log('props', props);
    // console.log('chartData', chartData);

    setChartData([]);
    setChartLabel([]);
    setChartData(props.prizesChartData.data);
    setChartLabel(props.prizesChartData.label);
    setBarStyle({
      ...barStyle,
      width: Math.max(50*props.prizesChartData.label.length, 400)
    });
  }, [props]);

  let color = [];

  for(let i = 0; i < chartData.length; i++) {
    color.push('#5685CE');
  }

  const barChartData = {
      labels: chartLabel,
      datasets:[{
          label: '2017',
          data: chartData['2017'],
          backgroundColor: '#AAFCA0'
        },
        {
          label: '2018',
          data: chartData['2018'],
          backgroundColor: '#A0AAFC' 
        },
        {
          label: '2019',
          data: chartData['2019'],
          backgroundColor: '#FCA0AA' 
        },
        {
          label: '2020',
          data: chartData['2020'],
          backgroundColor: '#FCFBA0'
        }
      ]
  }

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    plugins: {
      labels: {
        render: function (args) {
          return '';
        }
      }
    },
    layout: {
      padding: {
          left: window.screen.availWidth <= 700 ? 120: 60
      }
    },
    scales: {
      xAxes: [{
          stacked: true,
          display: true,
          ticks: {
            fontSize: window.screen.availWidth <= 700 ? 25: 15,
            suggestedMin: 0,    
            beginAtZero: true   
          },
          gridLines: {
              drawOnChartArea: false
          },
          maxBarThickness:100,
          barPercentage: 1.0,
      }],
      yAxes: [
        {
          stacked: true,
          display: false,
          ticks: {
              fontSize: window.screen.availWidth <= 700 ? 25: 15,
              suggestedMin: 0,    
              beginAtZero: true   
          },
          gridLines: {
              drawOnChartArea: false
          }
        }
      ]
     },
     tooltips: {
      titleFontSize: window.screen.availWidth <= 700 ? 30: 15,
      bodyFontSize: window.screen.availWidth <= 700 ? 30: 15
    } 
  }

  return (
      <div class="chart">
        <div class="chartContent">
          {!chartData && <div class="loader"><Loader /></div>}
          {chartData && <div style={{textAlign: 'center', fontSize: '24px'}}><b>Awards per company</b></div>}
          {chartData && 
            <div style={barStyle}>
              <Bar
                width={1000}
                height={2000}
                data={barChartData}
                options={barChartOptions}
              />
            </div>
          }
        </div>
      </div>
  );
}

export default PrizesChart;
